module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-20.98db5d05.jpg";